import type { IMenuItem } from '@platform/core/types';

/** Пункти власних меню прототипу з лічильником кольору попередження (тип запису → англійські підписи пунктів): база знань — «Потребує перегляду». */
const OWN_WARNINGS: Readonly<Record<string, readonly string[]>> = { kb: ['Due for review'] };

/**
 * Чи показувати лічильник пункту меню кольором попередження, коли записів більше нуля (прототип v4: countFg '#c2410c'): «Прострочено»
 * (пресет overdue) у кожному меню й пункти власних меню з прапорцем warn (kbNavManage: N('Due for review', …, true)). Чиста функція.
 */
export function isWarningItem(rtKey: string, item: Pick<IMenuItem, 'preset' | 'label'>): boolean {
  return item.preset === 'overdue' || (OWN_WARNINGS[rtKey] ?? []).includes(item.label.en ?? '');
}
